import moment from 'moment';

export const DATE_RANGE_LAST_7 = 7;
export const DATE_RANGE_LAST_30 = 30;
export const DATE_RANGE_LAST_60 = 60;
export const DATE_RANGE_LAST_90 = 90;
export const DATE_RANGE_CUSTOM = 0;

export const MIN_DATE = moment('2013/01/01', 'YYYY/MM/DD').startOf('year');
export const MAX_DATE = moment().endOf('day');
export const MAX_DATE_FUTURE = moment()
  .add(1, 'year')
  .endOf('day');

export default [
  { value: null, label: 'All Time' },
  { value: DATE_RANGE_LAST_7, label: 'Last 7 days' },
  { value: DATE_RANGE_LAST_30, label: 'Last 30 days' },
  { value: DATE_RANGE_LAST_60, label: 'Last 60 days' },
  { value: DATE_RANGE_LAST_90, label: 'Last 90 days' },
  { value: DATE_RANGE_CUSTOM, label: 'Custom' }
];

export const getDaysArray = function(start, end) {
  const dates = [];
  for (
    const date = new Date(start);
    date <= new Date(end);
    date.setDate(date.getDate() + 1)
  ) {
    dates.push(moment(date));
  }
  return dates;
};
